// Recent-brands tracking, persisted to localStorage.
//
// - SETTING_KEY: whether tracking is enabled (a user setting in the cog popup).
// - LIST_KEY:    ordered list of recently-visited brand userIds, most recent
//                first, de-duplicated and capped at MAX_RECENT.

const SETTING_KEY = "trackRecentBrands";
const LIST_KEY = "recentBrands";
const MAX_RECENT = 25;

export const isRecentBrandsEnabled = () =>
    localStorage.getItem(SETTING_KEY) === "true";

export const setRecentBrandsEnabled = (enabled) => {
    localStorage.setItem(SETTING_KEY, String(Boolean(enabled)));
};

export const getRecentBrands = () => {
    try {
        const parsed = JSON.parse(localStorage.getItem(LIST_KEY));
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

export const setRecentBrands = (list) => {
    localStorage.setItem(LIST_KEY, JSON.stringify(list));
};

export const clearRecentBrands = () => {
    localStorage.removeItem(LIST_KEY);
};

/**
 * Records a brand visit. No-op unless tracking is enabled. The visited userId
 * is moved to the front, duplicates removed, and the list capped.
 */
export const addRecentBrand = (userId) => {
    if (!isRecentBrandsEnabled()) {
        return;
    }
    const id = Number(userId);
    if (!id) {
        return;
    }
    const next = [id, ...getRecentBrands().filter((x) => x !== id)];
    setRecentBrands(next.slice(0, MAX_RECENT));
};
